import React from 'react'
import moment from 'moment'
import { Row, Col, Icon } from 'antd'
import * as styles from './index.scss'
import band from '../../assets/images/six_band.png'
import pen from '../../assets/images/six_pen.png'
import tea from '../../assets/images/six_tea.png'

interface Props {
  id?: number
  cover?: string
  name?: string
  region?: string
  depart?: string
  time?: number
  intro?: string
  desc?: string
  broken?: boolean
  onClick?: React.EventHandler<any>
}

const SixStar: React.SFC<Props> = ({
  id,
  cover,
  name,
  region,
  depart,
  time,
  intro,
  desc,
  broken,
  onClick,
}) => {
  const breakline = (width?) => (
    <div
      style={{
        width,
        backgroundColor: '#E4BB85',
      }}
      className={styles.breakLine}
    />
  )

  const breakavatar = (
    <div className={styles.breaksixAvatar}>
      <div className={styles.breaksixUnknown}>?</div>
    </div>
  )

  return (
    <div
      className={styles.starsix}
      style={{
        cursor: id ? 'pointer' : 'no-drop',
      }}
      onClick={id && onClick}
    >
      <Row>
        <Col span={14}>
          <div className={styles.starsixInfo}>
            <div className={styles.starsixInfoTitle}>
              <div className={styles.starsixInfoTitleValue}>
                {broken ? '下一个七星上将会是你吗？' : name}
              </div>
            </div>
            {broken ? (
              <div>
                {breakline(200)}
                {breakline(140)}
              </div>
            ) : (
              <>
                <div className={styles.starsixInfoDesc} />
                <div className={styles.starsixInfoTime}>
                  <span>单位：{`${region} ${depart}`}</span>
                  <span>晋级：{moment(time * 1000).format('YYYY-MM-DD')}</span>
                </div>
              </>
            )}
            <div className={styles.starsixIntro}>
              <div className={styles.starsixIntroTitle}>
                <img src={tea} width="26" />
                <span style={{ marginLeft: 8 }}>讲师介绍</span>
              </div>
              <div className={styles.starsixIntroContent} title={intro}>
                {broken ? (
                  <div>
                    {breakline(200)}
                    {breakline(140)}
                  </div>
                ) : (
                  intro
                )}
              </div>
            </div>
            <div className={styles.starsixIntro}>
              <div className={styles.starsixIntroTitle}>
                <img src={pen} width="26" />
                <span style={{ marginLeft: 8 }}>宣言</span>
              </div>
              <div className={styles.starsixIntroContent} title={desc}>
                {broken ? <div>{breakline('50%')}</div> : desc}
              </div>
            </div>
            <div
              className={styles.starforBottom}
              style={{
                opacity: id ? 0.8 : 0.5,
              }}
            >
              成长故事
              <Icon type="right" />
            </div>
          </div>
        </Col>
        <Col span={10}>
          <div className={styles.starsixPic}>
            {broken ? (
              breakavatar
            ) : (
              <div className={styles.starsixAvatar}>
                <div
                  style={{
                    borderRadius: 6,
                    backgroundImage: `url(${cover})`,
                    backgroundPosition: 'top center',
                    height: 261,
                  }}
                />
              </div>
            )}
            <img className={styles.starsixBand} src={band} height="90" />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SixStar
